import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Modal, Button, Form } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { useAgendaActionsContext } from '../../../contexts/AgendaActionsContext';

const EncaixeModal = ({ show, onHide }) => {
  const { encaixeAgenda } = useAgendaActionsContext();
  const [horarioEncaixe, setHorarioEncaixe] = useState();
  const [descricaoAtividade, setDescricaoAtividade] = useState('ENCAIXE');
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const med = searchParams.get('med');

  const handleConfirm = () => {
    if (!horarioEncaixe) return toast.warn('Preencha o horário!');
    if (isNaN(horarioEncaixe)) return toast.warn('O horário deve ser um número!');

    encaixeAgenda({
      CODMED: med,
      HORARIO: horarioEncaixe - 1,
      ATIVIDADE: descricaoAtividade,
    });
    setHorarioEncaixe();
    setDescricaoAtividade('ENCAIXE');
    onHide(); // vou deixar aqui por enquanto até refatorar o modal
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header className="font-weight-bold">
        Encaixar horário para médico {med}
      </Modal.Header>
      <Modal.Body>
        <Form.Label className="font-weight-bold">Horário de encaixe</Form.Label>
        <Form.Control
          value={horarioEncaixe}
          onChange={e => setHorarioEncaixe(e.target.value)}
        />
        <Form.Label className="font-weight-bold mt-3">Descrição da atividade</Form.Label>
        <Form.Control
          type="text"
          value={descricaoAtividade}
          onChange={e => setDescricaoAtividade(e.target.value.toUpperCase())}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleConfirm}>Confirmar</Button>
        <Button
          variant="danger"
          onClick={() => {
            setHorarioEncaixe();
            setDescricaoAtividade('ENCAIXE');
            onHide();
          }}
        >
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EncaixeModal;
